export const environment = {
  production: true,
  baseUrl: 'https://common.laalsa.com/helloRider',
  mapApiKey: 'AIzaSyAu7d9alua551hRqOmLLFd3sz4Kk2bORak',
};
